import { AssetType, JobType } from '@/enum'
import type { IIssue, IJobAssociatedAssetUpdate } from '@/interfaces'
import type { IAppUser } from '@/interfaces/app-user/IAppUser'
import type { IIssueJobForm } from '@/interfaces/jobs/issues/IIssueJobForm'
import AppUser from '@/models/AppUser'
import JobAssociatedAssetUpdate from '../JobAssociatedAssetUpdate'
import JobForm from '../JobForm'

class IssueJobForm extends JobForm implements IIssueJobForm {
  issueReporterId?: string
  issueReporter: IAppUser
  asset: IJobAssociatedAssetUpdate

  constructor(jobForm?: IIssue) {
    super(jobForm)
    this.type = JobType.ISSUE
    this.issueReporterId = jobForm?.issueReporterId
    this.issueReporter = new AppUser(jobForm?.issueReporter)
    this.asset = { 
      id: jobForm?.asset?.assetType == AssetType.VEHICLE
                ? jobForm?.asset?.vehicleId
                : jobForm?.asset?.assetType == AssetType.MACHINE ? jobForm?.asset?.machineId : jobForm?.asset?.equipmentId as string,
      type: jobForm?.asset?.assetType as any,
      vehicle: jobForm?.asset?.vehicle,
      equipment: jobForm?.asset?.equipment,
      machine: jobForm?.asset?.machine
    } 
  }
}

export default IssueJobForm
